<template>
  <router-view />
</template>

<script>
export default {
  name: "app-option"
};
</script>

<style lang="scss" scoped></style>
